'use strict';

yalwa.dol_landing = (function(pub) {
	
	pub = pub || {};
	
	pub.init = function() {
		document.addEventListener('scroll', sticky_link);
		document.addEventListener('scroll', count_up_animation);
		jQuery('.js-expand_button').on('click', expand_button_click_handler);
	}
	
	function expand_button_click_handler(event) {
		const $section = jQuery(event.currentTarget).closest('.js-section');
		jQuery(event.currentTarget).addClass('hide_button_with_animation');
		$section.find('.js-expand').addClass('visible');
	}
	
	/**
	 * Sticky JOIN NOW link
	 */
	const sticky_link = () => {
		const display_after = document.querySelector('.js-display_after');
		if (!display_after) {
			return;
		}
		const $element = jQuery('.js-sticky_link');
		const scroll_position = window.scrollY;
		if (scroll_position > (display_after.offsetTop + 40)) {
			$element.removeClass('hidden');
		} else {
			$element.addClass('hidden');
		}
	};
	
	let animation_loaded = false;
	
	const count_up_animation = () => {
		const display_after = document.querySelector('.js-stats');
		const scroll_position = window.scrollY;
		if (scroll_position + window.innerHeight > (display_after.offsetTop)) {
			if (!animation_loaded) {
				animation_loaded = true;
				document.querySelectorAll('.js-count_up').forEach(element => {
					count_up(element, 3000);
				});
			}
			
		}
	};
	
	/**
	 * Count Up plugin
	 * @param element
	 */
	const count_up = element => {
		if (!element) {
			console.error('No element could be found!')
			return;
		}
		
		const duration = element.dataset.duration;
		const count_to = +element.dataset.count;
		const interval_duration = duration / count_to;
		const interval_start_from = element.dataset.start ? +element.dataset.start : 0;
		const interval_step = Math.ceil((count_to - interval_start_from) / duration * 3.5);
		
		// Start from
		element.innerText = interval_start_from;
		
		// Increase the number
		let val;
		const increase = () => {
			if (+element.innerText >= count_to) {
				clearInterval(counter_interval);
				element.innerText = new Intl.NumberFormat('en-US', {maximumSignificantDigits: 3}).format(element.innerText) + element.dataset.suffix;
			} else {
				val = +element.innerText + interval_step;
				element.innerText = (val > count_to) ? count_to : val;
			}
		};
		const counter_interval = setInterval(increase, interval_duration);
	};
	
	return pub;
	
}(yalwa.dol_landing));

yalwa.basics.init_wrapper(yalwa.dol_landing.init);
